import RatingImage from '@/assets/Offboarding/RatingImage.svg';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogClose } from '@/components/ui/dialog';
import { RxCross1 } from 'react-icons/rx';

interface RatingModalProps {
  showRatingModal: boolean;
  setShowRatingModal: (show: boolean) => void;
  setShowSurvey: (show: boolean) => void;
  selectedRating: number | undefined;
  handleSurveyClick: () => void;
}

export const RatingModal = ({
  showRatingModal,
  setShowRatingModal,
  setShowSurvey,
  selectedRating,
  handleSurveyClick,
}: RatingModalProps) => {
  return (
    <Dialog
      open={showRatingModal}
      onOpenChange={(open) => {
        if (!open) {
          setShowRatingModal(false);
          setShowSurvey(false);
        }
      }}
    >
      <DialogContent>
        <div className="flex items-start justify-between rounded-t border-none p-2">
          <div />
          <DialogClose
            className="absolute top-3 right-2 h-8 rounded-lg p-1 mr-2 cursor-pointer focus:ring-0 focus:outline-hidden focus:border-transparent hover:bg-gray-100"
            onClick={() => {
              setShowRatingModal(false);
              setShowSurvey(false);
            }}
          >
            <RxCross1 className="h-5 w-5 text-gray-600 stroke-[0.2]" />
          </DialogClose>
        </div>
        {/* No h-full here: a percentage height inside the fit-content dialog is mis-resolved on
            iOS Safari and clips the modal body. Let the content size itself naturally. */}
        <div className="px-6 md:px-10 pb-6 pt-2 flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center w-full gap-2">
            <img src={RatingImage} alt="Rating Image" />

            <p className="text-3.5xl font-medium mt-3 text-left leading-9 mb-1">
              {selectedRating && selectedRating < 3
                ? 'Votre avis compte'
                : 'Merci pour votre retour !'}
            </p>

            <div className="flex flex-col text-sm text-start w-full leading-tight font-light">
              {selectedRating && selectedRating < 3 ? (
                <p>
                  Aidez-nous à comprendre ce qui
                  <br />
                  n&apos;a pas fonctionné (1 minute)
                </p>
              ) : (
                <p>
                  Si vous avez une minute, partagez votre
                  <br />
                  expérience de l&apos;application sur Trustpilot
                </p>
              )}
            </div>

            <Button
              variant="ctaPrimary"
              size="offboarding"
              className="mt-3 font-normal rounded-lg!"
              onClick={handleSurveyClick}
            >
              {selectedRating && selectedRating < 3
                ? 'Partager vos retours'
                : 'Partager mon expérience'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
